module.exports = __webpack_public_path__ + "img/lotus_logo.b9ab7ff0.png";